import Logger from './logger';

export default class DevLogger extends Logger {
  private Reset = '\x1b[0m';

  private FgCyan = '\x1b[36m';

  private FgRed = '\x1b[31m';

  private FgMagenta = '\x1b[35m';

  private FgYellow = '\x1b[33m';

  formatLogTypeColor(type: string) {
    if (type === 'warn') {
      return this.FgYellow;
    }
    if (type.toLowerCase().indexOf('error') !== -1) {
      return this.FgRed;
    }

    return this.FgCyan;
  }

  formatParam(key: string, value: any) {
    return `${this.FgYellow}$${key}${this.Reset}: "${value}"`;
  }

  formatOperation(type: string, name: string, params: Record<string, any>, duration: number) {
    const formattedParams = Object.keys(params)
      .map((k) => this.formatParam(k, params[k]))
      .join(', ');
    const formattedType = `${this.formatLogTypeColor(type)}${type}${this.Reset}`;
    const formattedName = `${this.FgMagenta}${name}${this.Reset}`;
    const formattedDuration = duration !== 0 ? `${this.FgCyan}${duration}${this.Reset}ms` : '';
    return `${formattedType} - ${formattedName}(${formattedParams}) ${formattedDuration}`;
  }
}
